import { Checkbox, Td, Text, Tr } from "@chakra-ui/react"
import { formatPrice } from "../../../utils/formatPrice"
import { formatDate } from "../../../utils/formatDate"

export function UsageTr({ data, key, nunota, setNunota, setSequencia, sequencia, codProd, setCodProd }) {
  function checkOrRemoveCheck(numero_nota, cod_prod, seq, checked) {
    if (checked) {
      setNunota([...nunota, numero_nota])
      setCodProd([...codProd, cod_prod])
      setSequencia([...sequencia, seq])
    } else if (!checked) {
      const newnunota = nunota.filter((item) => item !== numero_nota)
      const newCodProd = codProd.filter((item) => item !== cod_prod)
      const newSequencia = sequencia.filter((item) => item !== seq)

      setNunota(newnunota)
      setCodProd(newCodProd)
      setSequencia(newSequencia)
    }
  }

  return (
    <Tr key={key}>
      <Td textAlign="center">{formatDate(data.data_pedido)}</Td>
      <Td textAlign="center">{formatDate(data.data_saida_mercadoria)}</Td>
      <Td textAlign="center">
        <Text
          as="a"
          href={data.link_layout}
          target="_blank"
          rel="noreferrer"
          color={"blue.500"}
          textDecoration="underline"
        >
          {data.pedido_venda}
        </Text>
      </Td>
      <Td textAlign="center">{data.cod_innovation}</Td>
      <Td textAlign="center">{data.descricao}</Td>
      <Td textAlign="center">{data.cor_produto}</Td>
      <Td textAlign="center">{data.cod_fornecedor}</Td>
      <Td textAlign="center">{data.quantidade_troca}</Td>
      <Td textAlign="center">{formatDate(data.data_saida_mercadoria)}</Td>
      <Td textAlign="center">{data.pedido_troca}</Td>
      <Td textAlign="center">{data.pedido_compra}</Td>
      <Td textAlign="center">{formatPrice(data.valor_unitario_pedido)}</Td>
      <Td textAlign="center">{formatPrice(data.valor_total_pedido)}</Td>
      <Td textAlign="center">{data.credito_disponivel}</Td>
      <Td textAlign="center">
        <Checkbox
          borderColor="gray.300"
          defaultChecked={data.credito_utilizado === "S" ? true : false}
          disabled={data.credito_utilizado === "S" ? true : false}
          onChange={(e) =>
            checkOrRemoveCheck(data.pedido_compra, data.codigo_produto, data.sequencia, e.target.checked)
          }
        />
      </Td>
    </Tr>
  )
}
